import { render, staticRenderFns } from "./ItemSearchResult.vue?vue&type=template&id=01a08a7b&scoped=true&"
import script from "./ItemSearchResult.vue?vue&type=script&lang=js&"
export * from "./ItemSearchResult.vue?vue&type=script&lang=js&"
import style0 from "./ItemSearchResult.vue?vue&type=style&index=0&id=01a08a7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a08a7b",
  null
  
)

export default component.exports